import { useSetLiveStateData, useUserEditorState,useLiveStateData,
  useVeltClient, VeltHuddleTool, VeltSidebarButton, useLiveStateSyncUtils, useLiveSelectionUtils, useLive, VeltPresence } from '@veltdev/react';
import { useEffect, useState, useCallback } from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { createTheme } from '@uiw/codemirror-themes';
import {abcdef} from '@uiw/codemirror-themes-all'
import { tags as t } from '@lezer/highlight';

import {htmlLanguage} from '@codemirror/lang-html'
import { javascriptLanguage } from '@codemirror/lang-javascript';
import { cssLanguage } from '@codemirror/lang-css';

export default function YourDocument() {

  

  const [HTMLValue, setHTMLValue] = useState(`<footer>
  <nav class="clearfix">
    <ul class="left-links">
      <li><a href="">Advertising</a></li>
      <li><a href="">Business</a></li>
      <li><a href="">About</a></li>
    </ul>
    <ul class="right-links"> 
      <li><a href="">Privacy</a></li>
      <li><a href="">Terms</a></li>
      <li><a href="">Settings</a></li>
    </ul>
  </nav>
</footer>                        
`);


const onClickButton = () => {
  // setHTMLValue("test")
  liveStateSyncElement?.setUserAsEditor()
}



const onHTMLChange = (val, viewUpdate) => {
  
  console.log("onchange",val) 
  



  

  if(isEditor === true){
    let liveStateData = {
      HTMLValue: val 
    }

    liveStateSyncElement.setLiveStateData(liveStateDataId, liveStateData);
    console.log("setting live state data: ",liveStateData)
    // setHTMLValue(val)

  }



}

  const [CSSvalue, setCSSValue] = useState("console.log('CSS!');");
  const [JSValue, setJSValue] = useState("console.log('JS!');");


  // Get the Velt client
  const { client } = useVeltClient();
  let liveSelectionElement = useLiveSelectionUtils();
  liveSelectionElement?.enableLiveSelection(); //enables live selection mode
  let liveStateSyncElement = useLiveStateSyncUtils()
  liveStateSyncElement?.enableSingleEditorMode(); //enables single editor mode
  //liveStateSyncElement?.setUserAsEditor();

  let isEditor = useUserEditorState()
  let liveStateDataId = "js-fiddle-demo"



  liveStateSyncElement?.getLiveStateData(liveStateDataId).subscribe((data) => {
    console.log("liveStatedatupdate: ",data)
      if(isEditor !== true && isEditor !== null && isEditor !== undefined){
        console.log("isEditor?", isEditor)
        setHTMLValue(data)
      }
  });

  const myTheme = createTheme({
    theme: 'dark',
    settings: {
      background: '#202227',
      backgroundImage: '',
      foreground: '#75baff',
      caret: '#5d00ff',
      selection: '#036dd626',
      selectionMatch: '#036dd626',
      lineHighlight: '#8a91991a',
      gutterBackground: '#202227',
      gutterForeground: '#8a919966',
    },
    styles: [
      { tag: t.content,color:'white'},
      { tag: t.comment, color: '#787b8099' },
      { tag: t.variableName, color: '#0080ff' },
      { tag: [t.string, t.special(t.brace)], color: '#BFC0C1' },
      { tag: t.number, color: 'white' },
      { tag: t.bool, color: 'white' },
      { tag: t.null, color: 'white' },
      { tag: t.keyword, color: 'white' },
      { tag: t.operator, color: 'white' },
      { tag: t.className, color: '#E2A262' },
      { tag: t.definition(t.typeName), color: 'white' },
      { tag: t.typeName, color: 'white' },
      { tag: t.angleBracket, color: 'white' },
      { tag: t.tagName, color: '#FF4F68' },
      { tag: t.attributeName, color: '#E2A262' },
    ],
   
  });

  useEffect(() => {
    if (client) {
      // Set a document ID
      client.setDocumentId('jsfiddle-demo-id');
    }
  }, [client]);
  

  return (
    <html slick-uniqueid="3">
      <body
        className="gridMode_grid_1 fullyLoaded"
        data-skeleton-url="/css/dist-skeleton-dark.css?e593bda640ca544f190472035bf5fa35614c3bed"
      >
     
        <div id="_bsa_srv-CKYD52JI_0" />
        {'  '}
        <div
          className="_bsa_hide"
          data-attributes="{&quot;type&quot;:&quot;stickybox&quot;,&quot;key&quot;:&quot;CKYD52JI&quot;,&quot;segment&quot;:&quot;placement:jsfiddlenet-custom&quot;,&quot;options&quot;:{&quot;target&quot;:&quot;body&quot;,&quot;noViewable&quot;:true,&quot;script_id&quot;:&quot;_bsa_srv-CKYD52JI_0&quot;,&quot;platforms&quot;:[&quot;desktop&quot;,&quot;mobile&quot;],&quot;skippedVisible&quot;:true},&quot;ads&quot;:[{&quot;active&quot;:&quot;1&quot;,&quot;ad_via_link&quot;:&quot;https://discover.buysellads.com/carbon?utm_source=jsfiddle-net-sticky-box&utm_medium=ad_via_link&utm_campaign=in_unit&utm_term=stickybox&quot;,&quot;asset:image&quot;:&quot;1f4ff9ff57df02022698e6e361922626dbc9aef2&quot;,&quot;asset:logo&quot;:&quot;8e3e1d8330a6bfba2a14fa28efca6f09b7953c3c&quot;,&quot;backgroundColor&quot;:&quot;#FFFFFF&quot;,&quot;backgroundHoverColor&quot;:&quot;#FFFFFF&quot;,&quot;bannerid&quot;:&quot;522376&quot;,&quot;callToAction&quot;:&quot;Try now&quot;,&quot;company&quot;:&quot;AWS Marketplace&quot;,&quot;companyTagline&quot;:&quot;Try Aviatrix Secure Cloud Networking on AWS&quot;,&quot;creativeid&quot;:&quot;621377&quot;,&quot;ctaBackgroundColor&quot;:&quot;#DF5B19&quot;,&quot;ctaBackgroundHoverColor&quot;:&quot;#DF5B19&quot;,&quot;ctaTextColor&quot;:&quot;#FFFFFF&quot;,&quot;ctaTextColorHover&quot;:&quot;#FFFFFF&quot;,&quot;description&quot;:&quot;Aviatrix Secure Cloud Networking on AWS: Maintain visibility and security for AWS network traffic&quot;,&quot;evenodd&quot;:&quot;0&quot;,&quot;external_id&quot;:&quot;234216&quot;,&quot;height&quot;:&quot;0&quot;,&quot;i&quot;:&quot;0&quot;,&quot;identifier&quot;:&quot;5c04b5c85cd99a0736c8a57309729e9a&quot;,&quot;image&quot;:&quot;https://srv.buysellads.com/static/30242/1f4ff9ff57df02022698e6e361922626dbc9aef2&quot;,&quot;logo&quot;:&quot;https://srv.buysellads.com/static/30242/8e3e1d8330a6bfba2a14fa28efca6f09b7953c3c&quot;,&quot;longimp&quot;:&quot;TTMBZTDHTTTTTT6V6NDNPTTTTTT6DQWQKWTTTTTTTD5YT7VTTTTTT&quot;,&quot;longlink&quot;:&quot;T6MBZTDHTTTTTT6V6NDNPTTTTTT6DQWQKWTTTTTTTD5YT7VTTTTTTIQI2KSU4MSNGTBWALSZ5A7IKRBM5MFHK7LCFHAE&quot;,&quot;num_slots&quot;:&quot;1&quot;,&quot;rendering&quot;:&quot;stickybox&quot;,&quot;statimp&quot;:&quot;//srv.buysellads.com/ads/imp/x/GTND427ECVAI65QUCTSLYKQUCT7IC2QMCAADVZ3JCAYDC2QJF6ADT5QKF6SI553WFTADK23WCV7IEK3WF67IEKJKC6SITKJ7CEBDTK3EHJWNBADLKM7UCBZG2Y&quot;,&quot;statlink&quot;:&quot;//srv.buysellads.com/ads/click/x/GTND427ECVAI65QUCTSLYKQUCT7IC2QMCAADVZ3JCAYDC2QJF6ADT5QKF6SI553WFTADK23WCV7IEK3WF67IEKJKC6SITKJ7CEBDTK3EHJNCLSIZ&quot;,&quot;statview&quot;:&quot;//srv.buysellads.com/ads/viewable/x/GTND427ECVAI65QUCTSLYKQUCT7IC2QMCAADVZ3JCAYDC2QJF6ADT5QKF6SI553WFTADK23WCV7IEK3WF67IEKJKC6SITKJ7CEBDTK3EHJSCL7ZUKHJCY7V&quot;,&quot;textColor&quot;:&quot;#000000&quot;,&quot;textColorHover&quot;:&quot;#000000&quot;,&quot;timestamp&quot;:&quot;1702944102&quot;,&quot;width&quot;:&quot;0&quot;,&quot;zoneid&quot;:&quot;30763&quot;,&quot;zonekey&quot;:&quot;CKYD52JI&quot;}]}"
          id="_stickybox_"
        >
          <div className="stickybox-outer">
            <a
              className="stickybox-inner"
              href="//srv.buysellads.com/ads/click/x/GTND427ECVAI65QUCTSLYKQUCT7IC2QMCAADVZ3JCAYDC2QJF6ADT5QKF6SI553WFTADK23WCV7IEK3WF67IEKJKC6SITKJ7CEBDTK3EHJNCLSIZ?segment=placement:jsfiddlenet-custom"
              rel="sponsored noopener"
              target="_blank"
              title="AWS Marketplace — Try Aviatrix Secure Cloud Networking on AWS"
            >
              <div
                className="stickybox-banner"
                style={{
                  backgroundColor: '#FFFFFF'
                }}
              >
                <img
                  className="stickybox-logo"
                  data-no-statview="no"
                  height="50"
                  src="https://srv.buysellads.com/static/30242/8e3e1d8330a6bfba2a14fa28efca6f09b7953c3c"
                  width="125"
                />
                <div
                  className="stickybox-cta"
                  style={{
                    backgroundColor: '#DF5B19',
                    color: '#FFFFFF'
                  }}
                >
                  Try now
                </div>
              </div>
              <div className="stickybox-text">
                <div className="stickybox-description">
                  Aviatrix Secure Cloud Networking on AWS: Maintain visibility and security for AWS network traffic
                </div>
                <div className="stickybox-company">
                  Sponsored by AWS Marketplace
                </div>
              </div>
            </a>
            <div
              className="native-hide"
              style={{
                backgroundColor: '#000000',
                border: 'solid 2px #FFFFFF',
                color: '#FFFFFF'
              }}
            >
              <svg
                fill="#FFFFFF"
                height="16"
                viewBox="0 0 30 30"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M7 4a.995.995 0 0 0-.707.293l-2 2a.999.999 0 0 0 0 1.414L11.586 15l-7.293 7.293a.999.999 0 0 0 0 1.414l2 2a.999.999 0 0 0 1.414 0L15 18.414l7.293 7.293a.999.999 0 0 0 1.414 0l2-2a.999.999 0 0 0 0-1.414L18.414 15l7.293-7.293a.999.999 0 0 0 0-1.414l-2-2a.999.999 0 0 0-1.414 0L15 11.586 7.707 4.293A.996.996 0 0 0 7 4z" />
              </svg>
            </div>
            <div />
          </div>
        </div>
        {'    '}
        <div id="hello-bar">
          {'  '}
          <a
            className="closeHb"
            href="#"
          >
            {'    '}
            <svg
              fill="none"
              height="24"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              width="24"
            >
              <line
                x1="18"
                x2="6"
                y1="6"
                y2="18"
              />
              <line
                x1="6"
                x2="18"
                y1="6"
                y2="18"
              />
            </svg>
            Close{'  '}
          </a>
          {'  '}
          <div className="hbBody">
            {'    '}
            <section>
              {'      '}
              <h3>
                Start with a boilerplate:
              </h3>
              {'      '}
              <ul className="boilerplates">
                {'                '}
                <li>
                  <a href="/boilerplate/jquery">
                    jQuery
                  </a>
                </li>
                {'        '}
                <li>
                  <a href="/boilerplate/vue">
                    Vue
                  </a>
                </li>
                {'        '}
                <li>
                  <a href="/boilerplate/react-jsx">
                    React
                  </a>
                </li>
                {'        '}
                <li>
                  <a href="/boilerplate/react-jsx">
                    React + JSX
                  </a>
                </li>
                {'        '}
                <li>
                  <a href="/boilerplate/preact">
                    Preact
                  </a>
                </li>
                {'        '}
                <li>
                  <a href="/boilerplate/typescript">
                    TypeScript
                  </a>
                </li>
                {'        '}
                <li>
                  <a href="/boilerplate/coffeescript">
                    CoffeeScript
                  </a>
                </li>
                {'        '}
                <li>
                  <a href="/boilerplate/scss">
                    SCSS
                  </a>
                </li>
                {'        '}
                <li>
                  <a href="/boilerplate/responsive-css-grid">
                    CSS Grid
                  </a>
                </li>
                {'        '}
                <li>
                  <a href="/boilerplate/bootstrap">
                    Bootstrap
                  </a>
                </li>
                {'        '}
                <li>
                  <a href="/boilerplate/postcss">
                    PostCSS
                  </a>
                </li>
                {'      '}
              </ul>
              {'      '}
              <div className="bpAction hidden">
                {'        '}
                <svg
                  version="1.1"
                  viewBox="0 0 24 24"
                >
                  {'          '}
                  <g
                    fill="none"
                    stroke="#fff"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.4"
                  >
                    {'            '}
                    <path d="M17.94,17.94l-4.93766e-08,3.76374e-08c-1.70941,1.303 -3.79089,2.02486 -5.94,2.06c-7,0 -11,-8 -11,-8l-3.63017e-07,6.76516e-07c1.24389,-2.3181 2.96914,-4.34339 5.06,-5.94m3.84,-1.82l-5.75178e-07,1.34634e-07c0.688332,-0.161121 1.39306,-0.241661 2.1,-0.24c7,0 11,8 11,8l4.63472e-07,-8.67058e-07c-0.60702,1.13561 -1.33094,2.20473 -2.16,3.19m-6.72,-1.07l1.53825e-07,-1.65082e-07c-1.12951,1.21217 -3.02783,1.27918 -4.24,0.149667c-1.21217,-1.12951 -1.27918,-3.02783 -0.149667,-4.24c0.0481128,-0.0516337 0.0980326,-0.101554 0.149666,-0.149666" />
                    {'            '}
                    <path d="M1,1l22,22" />
                    {'          '}
                  </g>
                  {'        '}
                </svg>
                {'        '}
                <a href="#">
                  Show boilerplate bar less often?
                </a>
                {'      '}
              </div>
              {'    '}
            </section>
            {'    '}
            <section>
              {'      '}
              <h3>
                Links:
              </h3>
              {'      '}
              <ul>
                {'        '}
                <li>
                  👍🏻 {' '}
                  <a
                    href="https://trello.com/b/LakLkQBW/jsfiddle-roadmap"
                    rel="noopener"
                    target="_blank"
                  >
                    Roadmap
                  </a>
                  {' '}(vote for features)
                </li>
                
                {'        '}
                <li>
                  🐞{' '}
                  <a
                    href="https://github.com/jsfiddle/jsfiddle-issues/issues"
                    rel="noopener"
                    target="_blank"
                  >
                    Bug tracker
                  </a>
                </li>
                {'                '}
                <li>
                  📙{' '}
                  <a
                    href="https://docs.jsfiddle.net"
                    rel="noopener"
                    target="_blank"
                  >
                    Docs
                  </a>
                </li>
                {'        '}
                <li>
                  🎛{' '}
                  <a
                    href="http://status.jsfiddle.net"
                    rel="noopener"
                    target="_blank"
                  >
                    Service status
                  </a>
                </li>
                {'      '}
              </ul>
              {'        '}
              <a
                className="upgradeToPro"
                href="/extra/"
                target="_blank"
              >
                {'          '}
                <svg
                  version="1.1"
                  viewBox="0 0 24 24"
                >
                  {'            '}
                  <path
                    d="M12,2l3.09,6.26l6.91,1.01l-5,4.87l1.18,6.88l-6.18,-3.25l-6.18,3.25l1.18,-6.88l-5,-4.87l6.91,-1.01l3.09,-6.26Z"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.8"
                  />
                  {'          '}
                </svg>
                {'          '}
                <strong>
                  Support JSFiddle and get extra features
                </strong>
                {'          '}
                <em>
                  Groups, Private fiddles, Ad-free & more
                </em>
                {'        '}
              </a>
              {'    '}
            </section>
            {'    '}
            <section>
              {'      '}
              <h3>
                JSFiddle is for:
              </h3>
              {'      '}
              <ul className="articles">
                {'                '}
                <li>
                  <a
                    href="https://docs.jsfiddle.net/use-cases/demos-for-products-or-libraries"
                    rel="noopener"
                    target="_blank"
                  >
                    Demos for docs
                  </a>
                </li>
                {'        '}
                <li>
                  <a
                    href="https://docs.jsfiddle.net/use-cases/bug-reporting-test-case-for-github-issues"
                    rel="noopener"
                    target="_blank"
                  >
                    Bug reporting (test-case) for Github Issues
                  </a>
                </li>
                {'        '}
                <li>
                  <a
                    href="https://docs.jsfiddle.net/use-cases/answers-on-stack-overflow"
                    rel="noopener"
                    target="_blank"
                  >
                    Presenting code answers on Stack Overflow
                  </a>
                </li>
                {'        '}
                <li>
                  <a
                    href="https://docs.jsfiddle.net/use-cases/live-code-collaboration"
                    rel="noopener"
                    target="_blank"
                  >
                    Live code collaboration
                  </a>
                </li>
                {'        '}
                <li>
                  <a
                    href="https://docs.jsfiddle.net/use-cases/code-snippets-hosting"
                    rel="noopener"
                    target="_blank"
                  >
                    Code snippets hosting
                  </a>
                </li>
                {'        '}
                <li>
                  ... or just your humble code playground ✌🏻
                </li>
                {'      '}
              </ul>
              {'    '}
            </section>
            {'  '}
          </div>
        </div>
        {'            '}
        <form
          action="https://fiddle.jshell.net/_display/?editor_console=true"
          autoComplete="off"
          id="show-result"
          method="post"
          target="result"
        >
          {'      '}
          <input
            defaultValue="BhScDIkjdSbhGXLUTBIZpUZhdmZUICHSgT9odMhufcMy/fsa1VmztvvghmZbfA3lTWaiUJgoUsKbudLudadxsg=="
            name="authenticity_token"
            type="hidden"
          />
          {'      '}
          <header>
            {'        '}
            <h1>
              {'          '}
              <span className="title">
                JSFiddle
              </span>
              {'          '}
              <div className="changelog-badge">
                {'            '}
                <a
                  href="/"
                  title="JSFiddle"
                >
                  {'              '}
                  <svg
                    height="33px"
                    id="no-war"
                    viewBox="0 0 46 33"
                    width="46px"
                  >
                    {'                '}
                    <g
                      fill="none"
                      fillRule="evenodd"
                      strokeWidth="1.8"
                    >
                      {'                  '}
                      <path
                        d="M23.4888889,20.543316 C21.4404656,18.4187374 19.0750303,15.6666667 16.4832014,15.6666667 C13.8721947,15.6666667 11.7555556,17.6366138 11.7555556,20.0666667 C11.7555556,22.4967196 13.8721947,24.4666667 16.4832014,24.4666667 C18.8347252,24.4666667 19.9845474,23.0125628 20.6429148,22.312473"
                        id="Oval-1"
                        strokeLinecap="round"
                      />
                      {'                  '}
                      <path
                        d="M22.5111111,19.5900174 C24.5595344,21.7145959 26.9249697,24.4666667 29.5167986,24.4666667 C32.1278053,24.4666667 34.2444444,22.4967196 34.2444444,20.0666667 C34.2444444,17.6366138 32.1278053,15.6666667 29.5167986,15.6666667 C27.1652748,15.6666667 26.0154526,17.1207706 25.3570852,17.8208603"
                        id="Oval-1-Copy"
                        strokeLinecap="round"
                      />
                      {'                  '}
                      <path
                        d="M45,22.7331459 C45,19.1499462 42.7950446,16.079593 39.6628004,14.7835315 C39.6774469,14.5246474 39.7003932,14.2674038 39.7003932,14.0035978 C39.7003932,6.82243304 33.8412885,1 26.611593,1 C21.3985635,1 16.9102123,4.03409627 14.8051788,8.41527616 C13.7828502,7.62878013 12.503719,7.15547161 11.1134367,7.15547161 C7.77825654,7.15547161 5.07450503,9.84159999 5.07450503,13.1544315 C5.07450503,13.7760488 5.16938207,14.3779791 5.3477444,14.9418479 C2.74863428,16.4787471 1,19.2867709 1,22.5105187 C1,27.3287502 4.89630545,31.2367856 9.72803666,31.31094 L36.3341301,31.3109406 C41.1201312,31.3406346 45,27.4870665 45,22.7331459 L45,22.7331459 Z"
                        strokeLinejoin="round"
                      />
                      {'                '}
                    </g>
                    {'              '}
                  </svg>
                  {'            '}
                </a>
                {'          '}
              </div>
              {'        '}
            </h1>
            {'          '}
            <div id="actions">
              {'  '}
              <nav className="actionCont">
                
                {'    '}
                <div className="actionItem">
                  {'      '}
                  <a
                    onClick={onClickButton}
                    className="aiButton"
                    id="run"
                    title="Run (Command/Ctrl + Enter)"
                  >
                    {'        '}
                    <svg
                      className="feather feather-play"
                      fill="none"
                      height="24"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.4"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <polygon points="5 3 19 12 5 21 5 3" />
                    </svg>
                    {'        '}Run
                  </a>
                  {'    '}
                </div>
                {'          '}
                <div className="actionItem dropdown ">
                  {'        '}
                  <a
                    className="aiButton dropdownTrigger"
                    data-popover-trigger="saveInfo"
                    href="#save"
                    title="Save (Command/Ctrl + S)"
                  >
                    {'          '}
                    <svg
                      className="feather feather-upload-cloud"
                      fill="none"
                      height="24"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.4"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <polyline points="16 16 12 12 8 16" />
                      <line
                        x1="12"
                        x2="12"
                        y1="12"
                        y2="21"
                      />
                      <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
                      <polyline points="16 16 12 12 8 16" />
                    </svg>
                    {'          '}Save
                  </a>
                  {'      '}
                </div>
                {'      '}
                <div className="actionItem dropdown hidden">
                  {'        '}
                  <a
                    className="aiButton dropdownTrigger"
                    data-popover-trigger="forkInfo"
                    href="#fork"
                    title="Fork"
                  >
                    {'          '}
                    <svg
                      className="feather feather-shuffle"
                      fill="none"
                      height="24"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.4"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <polyline points="16 3 21 3 21 8" />
                      <line
                        x1="4"
                        x2="21"
                        y1="20"
                        y2="3"
                      />
                      <polyline points="21 16 21 21 16 21" />
                      <line
                        x1="15"
                        x2="21"
                        y1="15"
                        y2="21"
                      />
                      <line
                        x1="4"
                        x2="9"
                        y1="4"
                        y2="9"
                      />
                    </svg>
                    {'          '}Fork
                  </a>
                  {'      '}
                </div>
                {'    '}
                <div className="actionItem hidden ">
                  {'      '}
                  <a
                    className="aiButton"
                    href="#set-as-base"
                    id="mark_favourite"
                    title="Set as base"
                  >
                    {'        '}
                    <svg
                      className="feather feather-tag"
                      fill="none"
                      height="24"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.4"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
                      <line
                        x1="7"
                        x2="7"
                        y1="7"
                        y2="7"
                      />
                    </svg>
                    {'        '}Set as base
                  </a>
                  {'    '}
                </div>
                {'    '}
               
                {'    '}
                <div className="actionItem dropdown hidden ">
                  {'      '}
                  <a
                    className="aiButton dropdownTrigger"
                    data-popover-trigger="embed"
                    href="#embed"
                    id="share"
                    title="Embed"
                  >
                    {'        '}
                    <svg
                      fill="none"
                      height="24"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.4"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <polyline points="16 18 22 12 16 6" />
                      <polyline points="8 6 2 12 8 18" />
                    </svg>
                    {'        '}Embed
                  </a>
                  {'    '}
                </div>
                {'   '}
               
              </nav>
              {'  '}
              
              <ul className="actionCont dropdown right">
                <div className="">
                  
                    <div style={{display:"flex", gap:"18px", margin:"12px"}}>
                      <VeltPresence/>
                      <VeltHuddleTool style={{padding:"8px", height:"48px", width:"48px"}}/>
                      <div style={{marginTop:"4px"}}>
                        <VeltSidebarButton /> 
                      </div>
                      
                    </div>
                  
                  
                </div>
                
                {'  '}
              
                {'  '}
                <li className="actionItem">
                  {'    '}
                  <a
                    className="aiButton dropdownTrigger"
                    data-popover-trigger="editor-settings"
                    href="#"
                    title="Editor settings"
                  >
                    {'      '}
                    <svg
                      className="feather feather-sliders"
                      fill="none"
                      height="24"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.4"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <line
                        x1="4"
                        x2="4"
                        y1="21"
                        y2="14"
                      />
                      <line
                        x1="4"
                        x2="4"
                        y1="10"
                        y2="3"
                      />
                      <line
                        x1="12"
                        x2="12"
                        y1="21"
                        y2="12"
                      />
                      <line
                        x1="12"
                        x2="12"
                        y1="8"
                        y2="3"
                      />
                      <line
                        x1="20"
                        x2="20"
                        y1="21"
                        y2="16"
                      />
                      <line
                        x1="20"
                        x2="20"
                        y1="12"
                        y2="3"
                      />
                      <line
                        x1="1"
                        x2="7"
                        y1="14"
                        y2="14"
                      />
                      <line
                        x1="9"
                        x2="15"
                        y1="8"
                        y2="8"
                      />
                      <line
                        x1="17"
                        x2="23"
                        y1="16"
                        y2="16"
                      />
                    </svg>
                    {'      '}Settings{'    '}
                  </a>
                  {'  '}
                </li>
                {'     '}
                <li className="actionItem">
                  <a
                    className="aiButton"
                    href="/user/login/"
                  >
                    Sign in
                  </a>
                </li>
              </ul>
              <div
                className="dropdownCont hidden"
                data-popover-position="left"
                data-popover-ref="editor-settings"
              >
                {'  '}
                <div className="dcWrapper editorSettings">
                  {'    '}
                  <div id="editor-options">
                    {'      '}
                    <h3>
                      Editor layout
                    </h3>
                    {'      '}
                    <div id="layout">
                      {'                '}
                      <input
                        defaultValue="grid_invisible_hack"
                        name="layout"
                        style={{
                          display: 'none'
                        }}
                        type="radio"
                      />
                      {'        '}
                      <label>
                        {'          '}
                        <input
                          defaultChecked
                          defaultValue="1"
                          name="layout"
                          type="radio"
                        />
                        {'          '}
                        <span className="gridMode grid_1" />
                        {'          '}Classic{'        '}
                      </label>
                      {'        '}
                      <label>
                        {'          '}
                        <input
                          defaultValue="2"
                          name="layout"
                          type="radio"
                        />
                        {'          '}
                        <span className="gridMode grid_2" />
                        {'          '}Columns{'        '}
                      </label>
                      {'        '}
                      <label>
                        {'          '}
                        <input
                          defaultValue="3"
                          name="layout"
                          type="radio"
                        />
                        {'          '}
                        <span className="gridMode grid_3" />
                        {'          '}Bottom results{'        '}
                      </label>
                      {'        '}
                      <label>
                        {'          '}
                        <input
                          defaultValue="4"
                          name="layout"
                          type="radio"
                        />
                        {'          '}
                        <span className="gridMode grid_4" />
                        {'          '}Right results{'        '}
                      </label>
                      {'        '}
                      <label>
                        {'          '}
                        <input
                          defaultValue="5"
                          name="layout"
                          type="radio"
                        />
                        {'          '}
                        <span className="gridMode grid_5" />
                        {'          '}Tabs (columns){'        '}
                      </label>
                      {'        '}
                      <label>
                        {'          '}
                        <input
                          defaultValue="6"
                          name="layout"
                          type="radio"
                        />
                        {'          '}
                        <span className="gridMode grid_6" />
                        {'          '}Tabs (rows){'        '}
                      </label>
                      {'      '}
                    </div>
                    {'      '}
                    <h3>
                      Console
                    </h3>
                    {'      '}
                    <div className="fieldsCont">
                      {'        '}
                      <p className="proBadge">
                        {'          '}
                        <label className="checkboxCont ">
                          {'            '}
                          <input
                            name="editorConsole"
                            type="checkbox"
                          />
                          {'            '}
                          <span className="checkbox" />
                          {'            '}Console in the editor{' '}
                          <small>
                            (beta)
                          </small>
                          {'          '}
                        </label>
                        {'        '}
                      </p>
                      {'        '}
                      <p>
                        {'          '}
                        <label className="checkboxCont">
                          {'            '}
                          <input
                            name="clearConsole"
                            type="checkbox"
                          />
                          {'            '}
                          <span className="checkbox" />
                          {'            '}Clear console on run{'          '}
                        </label>
                        {'        '}
                      </p>
                      {'      '}
                    </div>
                    {'       '}
                    <h3>
                      General
                    </h3>
                    {'      '}
                    <div className="fieldsCont">
                      {'                '}
                      <p>
                        {'          '}
                        <label className="checkboxCont">
                          {'            '}
                          <input
                            defaultChecked
                            name="lineNumbers"
                            type="checkbox"
                          />
                          {'            '}
                          <span className="checkbox" />
                          {'            '}Line numbers{'          '}
                        </label>
                        {'        '}
                      </p>
                      {'        '}
                      <p>
                        {'          '}
                        <label className="checkboxCont">
                          {'            '}
                          <input
                            defaultChecked
                            name="lineWrapping"
                            type="checkbox"
                          />
                          {'            '}
                          <span className="checkbox" />
                          {'            '}Wrap lines{'          '}
                        </label>
                        {'        '}
                      </p>
                      {'        '}
                      <p>
                        {'          '}
                        <label className="checkboxCont">
                          {'            '}
                          <input
                            name="indentWithTabs"
                            type="checkbox"
                          />
                          {'            '}
                          <span className="checkbox" />
                          {'            '}Indent with tabs{'          '}
                        </label>
                        {'        '}
                      </p>
                      {'        '}
                      <p>
                        {'          '}
                        <label className="checkboxCont">
                          {'            '}
                          <input
                            name="codeHints"
                            type="checkbox"
                          />
                          {'            '}
                          <span className="checkbox" />
                          {'            '}Code hinting (autocomplete){' '}
                          <small>
                            (beta)
                          </small>
                          {'          '}
                        </label>
                        {'        '}
                      </p>
                      {'      '}
                    </div>
                    {'       '}
                    <div className="selectPairs">
                      {'        '}
                      <div className="selectPair">
                        {'          '}
                        <span className="label">
                          Indent size:
                        </span>
                        {'          '}
                        <div className="selectCont">
                          {'            '}
                          <select name="indentUnit">
                            {'              '}
                            <option value="2">
                              2 spaces
                            </option>
                            {'              '}
                            <option value="3">
                              3 spaces
                            </option>
                            {'              '}
                            <option value="4">
                              4 spaces
                            </option>
                            {'            '}
                          </select>
                          {'          '}
                        </div>
                        {'        '}
                      </div>
                      {'         '}
                      <div className="selectPair">
                        {'          '}
                        <span className="label">
                          Key map:
                        </span>
                        {'          '}
                        <div className="selectCont">
                          {'            '}
                          <select name="keyMap">
                            {'              '}
                            <option value="default">
                              Default
                            </option>
                            {'              '}
                            <option value="sublime">
                              Sublime Text
                            </option>
                            {'                            '}
                            <option value="emacs">
                              EMACS
                            </option>
                            {'            '}
                          </select>
                          {'          '}
                        </div>
                        {'        '}
                      </div>
                      {'         '}
                      <div className="selectPair">
                        {'          '}
                        <span className="label">
                          Font size:
                        </span>
                        {'          '}
                        <div className="selectCont">
                          {'            '}
                          <select name="fontSize">
                            {'              '}
                            <option value="1">
                              Default
                            </option>
                            {'              '}
                            <option value="2">
                              Big
                            </option>
                            {'              '}
                            <option value="3">
                              Bigger
                            </option>
                            {'              '}
                            <option value="4">
                              Jabba
                            </option>
                            {'            '}
                          </select>
                          {'          '}
                        </div>
                        {'        '}
                      </div>
                      {'       '}
                    </div>
                    {'       '}
                    <h3>
                      Behavior
                    </h3>
                    {'      '}
                    <div className="fieldsCont">
                      {'        '}
                      <p>
                        {'            '}
                        <label
                          className="checkboxCont disabled"
                          data-title="Log in to use auto-running"
                        >
                          {'              '}
                          <input
                            disabled
                            name="autoRun"
                            type="checkbox"
                          />
                          {'              '}
                          <span className="checkbox" />
                          {'              '}Auto-run code{'            '}
                        </label>
                        {'        '}
                      </p>
                      {'        '}
                      <p>
                        {'            '}
                        <label
                          className="checkboxCont disabled"
                          data-title="Log in to use auto-running"
                        >
                          {'              '}
                          <input
                            disabled
                            name="autoRunValid"
                            type="checkbox"
                          />
                          {'              '}
                          <span className="checkbox" />
                          {'              '}Only auto-run code that validates{'            '}
                        </label>
                        {'        '}
                      </p>
                      {'        '}
                      <p>
                        {'            '}
                        <label
                          className="checkboxCont disabled"
                          data-title="Log in to use auto-saving"
                        >
                          {'              '}
                          <input
                            disabled
                            name="autoSave"
                            type="checkbox"
                          />
                          {'              '}
                          <span className="checkbox" />
                          {'              '}Auto-save code (bumps the version){'            '}
                        </label>
                        {'        '}
                      </p>
                      {'        '}
                      <p>
                        {'          '}
                        <label className="checkboxCont">
                          {'            '}
                          <input
                            defaultChecked
                            name="autoCloseTags"
                            type="checkbox"
                          />
                          {'            '}
                          <span className="checkbox" />
                          {'            '}Auto-close HTML tags{'          '}
                        </label>
                        {'        '}
                      </p>
                      {'        '}
                      <p>
                        {'          '}
                        <label className="checkboxCont">
                          {'            '}
                          <input
                            defaultChecked
                            name="autoCloseBrackets"
                            type="checkbox"
                          />
                          {'            '}
                          <span className="checkbox" />
                          {'            '}Auto-close brackets{'          '}
                        </label>
                        {'        '}
                      </p>
                      {'        '}
                      <p>
                        {'          '}
                        <label className="checkboxCont">
                          {'            '}
                          <input
                            defaultChecked
                            name="codeLinting"
                            type="checkbox"
                          />
                          {'            '}
                          <span className="checkbox" />
                          {'            '}Live code validation{'          '}
                        </label>
                        {'        '}
                      </p>
                      {'        '}
                      <p>
                        {'          '}
                        <label className="checkboxCont">
                          {'            '}
                          <input
                            name="matchTags"
                            type="checkbox"
                          />
                          {'            '}
                          <span className="checkbox" />
                          {'            '}Highlight matching tags{'          '}
                        </label>
                        {'        '}
                      </p>
                      {'      '}
                    </div>
                    {'       '}
                    <h3>
                      Boilerplates
                    </h3>
                    {'      '}
                    <div className="fieldsCont">
                      {'        '}
                      <p>
                        {'          '}
                        <label className="checkboxCont">
                          {'            '}
                          <input
                            name="reduceHelloBar"
                            type="checkbox"
                          />
                          {'            '}
                          <span className="checkbox" />
                          {'            '}Show boilerplates bar less often{'          '}
                        </label>
                        {'        '}
                      </p>
                      {'      '}
                    </div>
                    {'     '}
                  </div>
                  {'   '}
                </div>
                {' '}
              </div>
              {' '}
              <div
                className="dropdownCont hidden"
                data-popover-position="left"
                data-popover-ref="upvote"
              >
                {'  '}
                <div
                  className="dcWrapper"
                  style={{
                    width: '640px'
                  }}
                >
                  {'        '}
                  <div
                    id="voting-iframe-cont"
                    style={{
                      left: '-10px',
                      position: 'relative',
                      width: 'calc(100% + 20px)'
                    }}
                  >
                    {'      '}Loading ...{'    '}
                  </div>
                  {'      '}
                </div>
              </div>
            </div>
            <div
              className="dropdownCont center hidden"
              data-popover-ref="saveInfo"
            >
              {'  '}
              <div className="dcWrapper info">
                {'    '}
                <p>
                  <strong>
                    Save anonymous (public) fiddle?
                  </strong>
                </p>
                {'    '}
                <p>
                  - Be sure not to include{' '}
                  <strong>
                    personal data
                  </strong>
                  <br />
                  - Do not include{' '}
                  <strong>
                    copyrighted material
                  </strong>
                </p>
                {'    '}
                <p className="warning">
                  <strong>
                    Log in
                  </strong>
                  {' '}if you'd like to{' '}
                  <strong>
                    delete this fiddle
                  </strong>
                  {' '}in the future.
                </p>
                {'    '}
                <button id="save">
                  Save
                </button>
                {'  '}
              </div>
            </div>
            <div
              className="dropdownCont center hidden"
              data-popover-ref="forkInfo"
            >
              {'  '}
              <div className="dcWrapper info">
                {'    '}
                <p>
                  <strong>
                    Fork anonymous (public) fiddle?
                  </strong>
                </p>
                {'    '}
                <p>
                  - Be sure not to include{' '}
                  <strong>
                    personal data
                  </strong>
                  <br />
                  - Do not include{' '}
                  <strong>
                    copyrighted material
                  </strong>
                </p>
                {'    '}
                <p className="warning">
                  <strong>
                    Log in
                  </strong>
                  {' '}if you'd like to{' '}
                  <strong>
                    delete this fiddle
                  </strong>
                  {' '}in the future.
                </p>
                {'    '}
                <button id="fork">
                  Fork
                </button>
                {'  '}
              </div>
            </div>
            <div
              className="dropdownCont center hidden"
              data-popover-ref="embed"
            >
              {'  '}
              <div className="dcWrapper embed">
                {'    '}
                <div id="creator">
                  {'      '}
                  <section>
                    {'        '}
                    <h3>
                      Tabs:
                    </h3>
                    {'        '}
                    <div className="inlineFields">
                      {'          '}
                      <label className="inputCont_checkbox checkboxCont">
                        {'            '}
                        <input
                          defaultChecked
                          defaultValue="js"
                          name="tabs"
                          type="checkbox"
                        />
                        {'            '}
                        <span className="checkbox">
                          <i className="bts bt-check" />
                        </span>
                        {' '}JavaScript{'          '}
                      </label>
                      {'          '}
                      <label className="inputCont_checkbox checkboxCont">
                        {'            '}
                        <input
                          defaultChecked
                          defaultValue="html"
                          name="tabs"
                          type="checkbox"
                        />
                        {'            '}
                        <span className="checkbox">
                          <i className="bts bt-check" />
                        </span>
                        {' '}HTML{'          '}
                      </label>
                      {'          '}
                      <label className="inputCont_checkbox checkboxCont">
                        {'            '}
                        <input
                          defaultChecked
                          defaultValue="css"
                          name="tabs"
                          type="checkbox"
                        />
                        {'            '}
                        <span className="checkbox">
                          <i className="bts bt-check" />
                        </span>
                        {' '}CSS{'          '}
                      </label>
                      {'          '}
                      <label className="inputCont_checkbox checkboxCont">
                        {'            '}
                        <input
                          defaultChecked
                          defaultValue="result"
                          name="tabs"
                          type="checkbox"
                        />
                        {'            '}
                        <span className="checkbox">
                          <i className="bts bt-check" />
                        </span>
                        {' '}Result{'          '}
                      </label>
                      {'        '}
                    </div>
                    {'       '}
                  </section>
                  {'      '}
                  <section className="noborder">
                    {'        '}
                    <h3>
                      Visual:
                    </h3>
                    {'        '}
                    <div className="inlineFields">
                      {'          '}
                      <label className="inputCont_checkbox checkboxCont">
                        {'            '}
                        <input
                          defaultChecked
                          defaultValue="light"
                          name="skin"
                          type="radio"
                        />
                        {'            '}
                        <span className="radio" />
                        {' '}Light{'          '}
                      </label>
                      {'          '}
                      <label className="inputCont_checkbox checkboxCont">
                        {'            '}
                        <input
                          defaultValue="dark"
                          name="skin"
                          type="radio"
                        />
                        {'            '}
                        <span className="radio" />
                        {' '}Dark{'          '}
                      </label>
                      {'        '}
                    </div>
                    {'         '}
                    <label className="inputCont_text">
                      {'          '}
                      <input
                        maxLength="7"
                        name="accentColor"
                        placeholder="Accent color"
                        type="text"
                      />
                      {'        '}
                    </label>
                    {'        '}
                    <label className="inputCont_text">
                      {'          '}
                      <input
                        maxLength="7"
                        name="fontColor"
                        placeholder="Font color"
                        type="text"
                      />
                      {'        '}
                    </label>
                    {'        '}
                    <label className="inputCont_text">
                      {'          '}
                      <input
                        maxLength="7"
                        name="menuColor"
                        placeholder="Menu background"
                        type="text"
                      />
                      {'        '}
                    </label>
                    {'        '}
                    <label className="inputCont_text">
                      {'          '}
                      <input
                        maxLength="7"
                        name="bodyColor"
                        placeholder="Code background"
                        type="text"
                      />
                      {'        '}
                    </label>
                    {'      '}
                  </section>
                  {'      '}
                  <section className="noborder">
                    {'        '}
                    <h3>
                      {'          '}Embed snippet{'          '}
                      <a
                        className="codeTypeToggle"
                        href="#"
                      >
                        Prefer iframe?
                      </a>
                      :{'        '}
                    </h3>
                    {'        '}
                    <div className="embedCodeWrap">
                      <textarea
                        className="embedCode"
                        data-pattern-value=""
                        data-view="embed"
                        defaultValue="<script async src=&quot;{embedSrc}&quot;></script>"
                        id="share_embedded_dropdown"
                      />
                      {'        '}
                    </div>
                    {'         '}
                    <div className="embedCodeWrap hidden">
                      <textarea
                        className="embedCode"
                        data-pattern-value="<iframe width=&quot;100%&quot; height=&quot;300&quot; src=&quot;{embedSrc}&quot; allowfullscreen=&quot;allowfullscreen&quot; allowpaymentrequest frameborder=&quot;0&quot;></iframe>"
                        data-view="embedded"
                        defaultValue="<iframe width=&quot;100%&quot; height=&quot;300&quot; src=&quot;{embedSrc}&quot; allowfullscreen allowpaymentrequest frameborder=&quot;0&quot;></iframe>"
                      />
                      {'          '}
                      <p>
                        <strong>
                          No autoresizing
                        </strong>
                        {' '}to fit the code
                      </p>
                      <p>
                        <strong>
                          Render blocking
                        </strong>
                        {' '}of the parent page
                      </p>
                      {'        '}
                    </div>
                    {'       '}
                  </section>
                  {'    '}
                </div>
                {'     '}
                <div id="preview" />
                {'   '}
              </div>
              {' '}
            </div>
            {'         '}
            <div id="progressbar">
              <div className="pb" />
            </div>
            {'      '}
          </header>
          {'        '}
          <main id="layout-container">
            {'          '}
            <div id="sidebar">
              {'            '}
              <section id="s-cont">
                {'              '}
                <div
                  className="hidden"
                  id="profile-segment"
                >
                  {'                              '}
                </div>
                {'              '}
                <div className="sidebarItem opened">
                  {'  '}
                  <h3
                    className="toggler"
                    title=""
                  >
                    {'    '}Fiddle meta{'  '}
                  </h3>
                  {'  '}
                  <div className="body">
                    {'    '}
                    <p>
                      {'      '}
                      <input
                        defaultValue=""
                        maxLength="255"
                        name="title"
                        placeholder="Untitled fiddle"
                        type="text"
                      />
                      {'    '}
                    </p>
                    {'    '}
                    <p>
                      {'      '}
                      <textarea
                        cols="40"
                        name="description"
                        placeholder="No description"
                        rows="10"
                      />
                      {'    '}
                    </p>
                    {'    '}
                    <p className="privateFiddleCont">
                      {'      '}
                      <label className="checkboxCont proBadge">
                        {'        '}
                        <input
                          defaultValue="1"
                          disabled
                          name="is_private"
                          type="checkbox"
                        />
                        {'        '}
                        <span className="checkbox" />
                        {'        '}Private fiddle{'        '}
                        <a
                          className="proBadgeSelf"
                          href="/extra/"
                          target="_blank"
                        >
                          Extra
                        </a>
                        {'      '}
                      </label>
                      {'    '}
                    </p>
                    {'  '}
                  </div>
                  {' '}
                </div>
                {'               '}
                <div className="sidebarItem">
                  {'  '}
                  <h3 className="toggler proBadge">
                    {'    '}Groups{' '}
                    <a
                      className="proBadgeSelf"
                      href="/extra/"
                      target="_blank"
                    >
                      Extra
                    </a>
                    {'  '}
                  </h3>
                  {'  '}
                  <div className="body">
                    {'    '}
                    <ul className="groupsList toggleGroupPrivacy" />
                    {'     '}
                    <div id="choices-select">
                      <div
                        aria-autocomplete="list"
                        aria-expanded="false"
                        aria-haspopup="true"
                        className="choices"
                        data-type="select-multiple"
                        role="combobox"
                      >
                        <div className="choices__inner">
                          <select
                            className="choices__input"
                            data-choice="active"
                            hidden
                            multiple
                            name="ignore_this_select"
                            tabIndex="-1"
                          />
                          <div className="choices__list choices__list--multiple" />
                          <input
                            aria-autocomplete="list"
                            aria-label="false"
                            autoCapitalize="off"
                            autoComplete="off"
                            className="choices__input choices__input--cloned"
                            role="textbox"
                            spellCheck="false"
                            type="text"
                          />
                        </div>
                        <div
                          aria-expanded="false"
                          className="choices__list choices__list--dropdown"
                        >
                          <div
                            aria-multiselectable="true"
                            className="choices__list"
                            role="listbox"
                          >
                            <div
                              aria-disabled="true"
                              className="choices__item choices__item--choice choices__item--disabled"
                              data-choice=""
                              data-choice-disabled=""
                              data-id="1"
                              data-select-text="Press to select"
                              data-value=""
                              id="choices--ignore_this_select-g3-item-choice-1"
                              role="option"
                            >
                              You have no groups
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {'  '}
                  </div>
                  {' '}
                </div>
                {'               '}
                <div className="sidebarItem">
                  {'  '}
                  <h3 className="toggler ">
                    {'    '}Resources{' '}
                    <strong className="resourcesLabel">
                      URL
                    </strong>
                    {' '}
                    <strong className="resourcesLabel">
                      cdnjs
                    </strong>
                    {'    '}
                    <em
                      className="hidden"
                      id="resource-counter"
                    >
                      0
                    </em>
                    {'  '}
                  </h3>
                  {'  '}
                  <div className="body">
                    {'    '}
                    <ul id="external_resources_list">
                      {'    '}
                    </ul>
                    {'    '}
                    <div id="external-resources-form">
                      {'      '}
                      <p>
                        {'        '}
                        <input
                          autoComplete="off"
                          defaultValue=""
                          id="external_resource"
                          name="q"
                          placeholder="JavaScript/CSS URL"
                          type="text"
                        />
                        {'        '}
                        <a
                          className="submit"
                          href="#"
                          id="add_external_resource"
                          title="Add resource"
                        >
                          {'          '}
                          <svg
                            className="feather feather-plus-circle"
                            fill="none"
                            height="24"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                            width="24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="12"
                              cy="12"
                              r="10"
                            />
                            <line
                              x1="12"
                              x2="12"
                              y1="8"
                              y2="16"
                            />
                            <line
                              x1="8"
                              x2="16"
                              y1="12"
                              y2="12"
                            />
                          </svg>
                          {'        '}
                        </a>
                        {'      '}
                      </p>
                      {'    '}
                    </div>
                    {'    '}
                    <input
                      defaultValue=""
                      id="external_resources_id"
                      name="add_external_resources"
                      type="hidden"
                    />
                    {'    '}
                    <ul className="resourcesInfo">
                      {'      '}
                      <li>
                        Paste a direct CSS/JS URL
                      </li>
                      {'      '}
                      <li>
                        Type a library name to fetch from CDNJS
                      </li>
                      {'    '}
                    </ul>
                    {'  '}
                  </div>
                  {' '}
                </div>
                {'               '}
                <div className="sidebarItem">
                  {'  '}
                  <h3 className="toggler">
                    {'    '}Async requests{'  '}
                  </h3>
                  {'  '}
                  <div className="body">
                    {'    '}
                    <p>
                      <code>
                        /echo
                      </code>
                      {' '}simulates Async calls:
                      <br />
                      {'      '}JSON:{' '}
                      <code>
                        /echo/json/
                      </code>
                      <br />
                      {'      '}JSONP:{' '}
                      <code>
                        //jsfiddle.net/echo/jsonp/
                      </code>
                      <br />
                      {'      '}HTML:{' '}
                      <code>
                        /echo/html/
                      </code>
                      <br />
                      {'      '}XML:{' '}
                      <code>
                        /echo/xml/
                      </code>
                      {'    '}
                    </p>
                    {'    '}
                    <p>
                      See{' '}
                      <a
                        href="https://jsfiddle.gitbook.io/help/async-requests"
                        target="_new"
                      >
                        docs
                      </a>
                      {' '}for more info.
                    </p>
                    {'  '}
                  </div>
                  {' '}
                </div>
                {'               '}
                <div className="sidebarItem">
                  {'  '}
                  <h3 className="toggler">
                    {'    '}Other (links, license){'  '}
                  </h3>
                  {'  '}
                  <div className="body">
                    {'    '}
                    <p className="maintainers">
                      Created and maintained by{' '}
                      <a
                        href="https://twitter.com/zalun"
                        rel="noopener"
                        target="_blank"
                        title="Piotr's twitter"
                      >
                        Piotr
                      </a>
                      {' '}and{' '}
                      <a
                        href="https://twitter.com/oskar"
                        rel="noopener"
                        target="_blank"
                        title="UX and UI Designer"
                      >
                        Oskar
                      </a>
                      .
                    </p>
                    {'    '}
                    <p>
                      Hosted on{' '}
                      <a
                        href="https://m.do.co/c/52e7a0ad196d"
                        rel="noopener"
                        target="_blank"
                      >
                        <strong>
                          DigitalOcean
                        </strong>
                      </a>
                    </p>
                    {'    '}
                    <p>
                      <strong />
                    </p>
                    {'    '}
                    <p>
                      All code belongs to the poster and no license is enforced. JSFiddle or its authors are not responsible or liable for any loss or damage of any kind during the usage of provided code.
                    </p>
                    {'    '}
                    <p>
                      <strong>
                        Links
                      </strong>
                    </p>
                    {'    '}
                    <p>
                      {'      '}
                      <a
                        href="https://github.com/jsfiddle/jsfiddle-issues/issues"
                        rel="noopener"
                        target="_blank"
                      >
                        Bug tracker
                      </a>
                      <br />
                      {'      '}
                      <a
                        href="https://jsfiddle.net/about"
                        rel="noopener"
                        target="_blank"
                      >
                        About
                      </a>
                      <br />
                      {'      '}
                      <a
                        href="https://docs.jsfiddle.net"
                        rel="noopener"
                        target="_blank"
                      >
                        Docs
                      </a>
                      <br />
                      {'      '}
                      <a
                        href="http://status.jsfiddle.net"
                        rel="noopener"
                        target="_blank"
                      >
                        Service status
                      </a>
                      {'    '}
                    </p>
                    {'  '}
                  </div>
                  {' '}
                </div>
                {'                           '}
              </section>
              {'              '}
              <section id="s-bottom">
                {'                '}
                <div className="twitterCont">
                  {'        '}
                  <div id="carbonads">
                    <span>
                      <span className="carbon-wrap">
                          
                        <a
                          className="carbon-img"
                          href="https://srv.carbonads.net/ads/click/x/GTND427ECVAI653UC6BLYKQUCT7IC27LCEBIEZ3JCAYDC2QLCKADEK7KF6SI553WFTADK23WCV7IEK3WF67IEKJKC6SITKJ7CEBDTK3EHJNCLSIZ"
                          rel="noopener sponsored"
                          target="_blank"
                        >
                              
                          <img
                            alt="ads via Carbon"
                            border="0"
                            data-no-statview="no"
                            height="100"
                            src="https://srv.carbonads.net/static/30242/f2d5d31fc61ac45219380769d2c4dfcda54f8f41"
                            style={{
                              maxWidth: '130px'
                            }}
                            width="130"
                          />
                            
                        </a>
                          
                        <a
                          className="carbon-text"
                          href="https://srv.carbonads.net/ads/click/x/GTND427ECVAI653UC6BLYKQUCT7IC27LCEBIEZ3JCAYDC2QLCKADEK7KF6SI553WFTADK23WCV7IEK3WF67IEKJKC6SITKJ7CEBDTK3EHJNCLSIZ"
                          rel="noopener sponsored"
                          target="_blank"
                        >
                              Personalize marketing at scale with 10+ Built-in AI Models	
                        </a>
                      </span>
                      <a
                        className="carbon-poweredby"
                        href="http://carbonads.net/?utm_source=jsfiddlenet&utm_medium=ad_via_link&utm_campaign=in_unit&utm_term=carbon"
                        rel="noopener sponsored"
                        target="_blank"
                      >
                        ads via Carbon
                      </a>
                      <div
                        className="carbon-pixels"
                        style={{
                          display: 'none'
                        }}
                      >
                        <img
                          alt="ads via Carbon"
                          border="0"
                          height="1"
                          src="https://ad.doubleclick.net/ddm/trackimp/N1224323.3091281BUYSELLADS/B30182242.374361042;dc_trk_aid=564983956;dc_trk_cid=197353956;ord=170294410;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=;dc_tdv=1?"
                          style={{
                            display: 'none'
                          }}
                          width="1"
                        />
                        <img
                          alt="ads via Carbon"
                          border="0"
                          height="1"
                          src="https://pixel.adsafeprotected.com/rfw/st/1566594/73361143/skeleton.gif?gdpr=$&gdpr_consent=$&gdpr_pd=$"
                          style={{
                            display: 'none'
                          }}
                          width="1"
                        />
                        <img
                          alt="ads via Carbon"
                          border="0"
                          height="1"
                          src="https://track.activemetering.com/pixel/v1/all/pixel.gif?cid=be85ddda-b98f-47c0-be54-a1f5f5656cb3&creativeId=197353956&placementId=374361042"
                          style={{
                            display: 'none'
                          }}
                          width="1"
                        />
                      </div>
                    </span>
                  </div>
                </div>
                <div id="support-jsfiddle">
                  {'  '}
                  <h3>
                    Support the development of JSFiddle and get extra features ✌🏻
                  </h3>
                  {'  '}
                  <a href="/extra/">
                    Become a supporter
                  </a>
                </div>
                <div id="fallback">
                  {'  '}
                  <a
                    href="https://instagram.com/oskarkrawczyk"
                    target="_blank"
                  >
                    {'    '}
                    <h3>
                      Lifestyle, adventure and backstage photographer based in Warsaw, Poland.
                    </h3>
                    {'    '}
                    <img src="https://jsfiddle.net/img/fallback/logo-adunit.jpg" />
                    {'  '}
                  </a>
                </div>
                {'              '}
              </section>
              {'          '}
            </div>
            {'           '}
            <div id="content">
              {'            '}
              <div id="editor">
                {'        '}
                <div
                  className="panel-v left"
                  style={{
                    width: 'calc(50% - 0.5px)'
                  }}
                >
                  {'          '}
                  <div
                    className="panel-h panel"
                    style={{
                      height: 'calc(50% - 0.5px)'
                    }}
                  >
                    {'            '}
                    <textarea
                      id="id_code_html"
                      name="code_html"
                      style={{
                        display: 'none'
                      }}
                    />
                    {'                    '}
                    <div className="windowLabelCont">
                      {'          '}
                      <a
                        className="windowLabel"
                        data-panel="html"
                        data-popover-trigger="html"
                        href="#"
                      >
                        {'            '}
                        <span className="label">
                          HTML
                        </span>
                        {'            '}
                        <svg
                          height="7"
                          viewBox="-0.019531 -52.792969 30.039062 25.195312"
                          width="8"
                        >
                          {'              '}
                          <path d="M29.941406 -52.500000C29.785156 -52.656250 29.589844 -52.753906 29.355469 -52.792969L0.644531 -52.792969C0.410156 -52.753906 0.214844 -52.656250 0.058594 -52.500000C-0.019531 -52.265625 0.000000 -52.050781 0.117188 -51.855469L14.472656 -27.890625C14.628906 -27.734375 14.804688 -27.636719 15.000000 -27.597656C15.234375 -27.636719 15.410156 -27.734375 15.527344 -27.890625L29.882812 -51.855469C30.000000 -52.089844 30.019531 -52.304688 29.941406 -52.500000ZM29.941406 -52.500000" />
                          {'            '}
                        </svg>
                        {'          '}
                      </a>
                      {'          '}
                      <a
                        className="panelTidy"
                        data-panel="html"
                        href="#"
                      >
                        {'          '}
                        <svg
                          className="feather feather-align-left"
                          fill="none"
                          height="14"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.4"
                          viewBox="0 0 24 24"
                          width="14"
                        >
                          <line
                            x1="17"
                            x2="3"
                            y1="10"
                            y2="10"
                          />
                          <line
                            x1="21"
                            x2="3"
                            y1="6"
                            y2="6"
                          />
                          <line
                            x1="21"
                            x2="3"
                            y1="14"
                            y2="14"
                          />
                          <line
                            x1="17"
                            x2="3"
                            y1="18"
                            y2="18"
                          />
                        </svg>
                        {' '}Tidy
                      </a>
                      {'        '}
                    </div>
                    {'          '}
                    <div
                      className="CodeMirror cm-s-default CodeMirror-wrap fontSize_1"
                      style={{
                        clipPath: 'inset(0px)'
                      }}
                      translate="no"
                    >
                      <div
                        style={{
                          height: '0px',
                          left: '213.242px',
                          overflow: 'hidden',
                          position: 'relative',
                          top: '20.8px',
                          width: '3px'
                        }}
                      >
                        <textarea
                          autoCapitalize="off"
                          autoCorrect="off"
                          spellCheck="false"
                          style={{
                            bottom: '-1em',
                            height: '1em',
                            minHeight: '1em',
                            outline: 'none',
                            padding: '0px',
                            position: 'absolute',
                            width: '1000px'
                          }}
                          tabIndex="0"
                        />
                      </div>
                      <div
                        className="CodeMirror-vscrollbar"
                        cm-not-content="true"
                        style={{
                          visibility: 'hidden',
                          width: '18px'
                        }}
                        tabIndex="-1"
                      >
                        <div
                          style={{
                            height: '0px',
                            minWidth: '1px'
                          }}
                        />
                      </div>
                      <div
                        className="CodeMirror-hscrollbar"
                        cm-not-content="true"
                        style={{
                          height: '18px',
                          visibility: 'hidden'
                        }}
                        tabIndex="-1"
                      >
                        <div
                          style={{
                            height: '100%',
                            minHeight: '1px',
                            width: '0px'
                          }}
                        />
                      </div>
                      <div
                        className="CodeMirror-scrollbar-filler"
                        cm-not-content="true"
                      />
                      <div
                        className="CodeMirror-gutter-filler"
                        cm-not-content="true"
                      />
                      <div>
                        <CodeMirror onChange={onHTMLChange} extensions={[htmlLanguage]} theme={myTheme} value={HTMLValue} height="600px" />
                      </div>
                    </div>
                  </div>
                  {'          '}
                  <div
                    className="gutter gutter-vertical"
                    style={{
                      height: '1px'
                    }}
                  />
                  <div
                    className="panel-h panel"
                    style={{
                      height: 'calc(50% - 0.5px)'
                    }}
                  >
                    {'            '}
                    <textarea
                      id="id_code_js"
                      name="code_js"
                      style={{
                        display: 'none'
                      }}
                    />
                    {'                    '}
                    <div className="windowLabelCont">
                      {'          '}
                      <a
                        className="windowLabel"
                        data-panel="js"
                        data-popover-trigger="js"
                        href="#"
                      >
                        {'            '}
                        <span className="label">
                          JavaScript + No-Library (pure JS)
                        </span>
                        {'            '}
                        <svg
                          height="7"
                          viewBox="-0.019531 -52.792969 30.039062 25.195312"
                          width="8"
                        >
                          {'              '}
                          <path d="M29.941406 -52.500000C29.785156 -52.656250 29.589844 -52.753906 29.355469 -52.792969L0.644531 -52.792969C0.410156 -52.753906 0.214844 -52.656250 0.058594 -52.500000C-0.019531 -52.265625 0.000000 -52.050781 0.117188 -51.855469L14.472656 -27.890625C14.628906 -27.734375 14.804688 -27.636719 15.000000 -27.597656C15.234375 -27.636719 15.410156 -27.734375 15.527344 -27.890625L29.882812 -51.855469C30.000000 -52.089844 30.019531 -52.304688 29.941406 -52.500000ZM29.941406 -52.500000" />
                          {'            '}
                        </svg>
                        {'          '}
                      </a>
                      {'          '}
                      <a
                        className="panelTidy"
                        data-panel="js"
                        href="#"
                      >
                        {'          '}
                        <svg
                          className="feather feather-align-left"
                          fill="none"
                          height="14"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.4"
                          viewBox="0 0 24 24"
                          width="14"
                        >
                          <line
                            x1="17"
                            x2="3"
                            y1="10"
                            y2="10"
                          />
                          <line
                            x1="21"
                            x2="3"
                            y1="6"
                            y2="6"
                          />
                          <line
                            x1="21"
                            x2="3"
                            y1="14"
                            y2="14"
                          />
                          <line
                            x1="17"
                            x2="3"
                            y1="18"
                            y2="18"
                          />
                        </svg>
                        {' '}Tidy
                      </a>
                      {'        '}
                    </div>
                    {'          '}
                    <div
                      className="CodeMirror cm-s-default CodeMirror-wrap fontSize_1"
                      style={{
                        clipPath: 'inset(0px)'
                      }}
                      translate="no"
                    >
                      <div
                        style={{
                          height: '0px',
                          left: '62px',
                          overflow: 'hidden',
                          position: 'relative',
                          top: '4px',
                          width: '3px'
                        }}
                      >
                        <textarea
                          autoCapitalize="off"
                          autoCorrect="off"
                          spellCheck="false"
                          style={{
                            bottom: '-1em',
                            height: '1em',
                            minHeight: '1em',
                            outline: 'none',
                            padding: '0px',
                            position: 'absolute',
                            width: '1000px'
                          }}
                          tabIndex="0"
                        />
                      </div>
                      <div
                        className="CodeMirror-vscrollbar"
                        cm-not-content="true"
                        style={{
                          visibility: 'hidden',
                          width: '18px'
                        }}
                        tabIndex="-1"
                      >
                        <div
                          style={{
                            height: '0px',
                            minWidth: '1px'
                          }}
                        />
                      </div>
                      <div
                        className="CodeMirror-hscrollbar"
                        cm-not-content="true"
                        style={{
                          height: '18px',
                          visibility: 'hidden'
                        }}
                        tabIndex="-1"
                      >
                        <div
                          style={{
                            height: '100%',
                            minHeight: '1px',
                            width: '0px'
                          }}
                        />
                      </div>
                      <div
                        className="CodeMirror-scrollbar-filler"
                        cm-not-content="true"
                      />
                      <div
                        className="CodeMirror-gutter-filler"
                        cm-not-content="true"
                      />
                      <div>
                      <CodeMirror extensions={[javascriptLanguage]} theme={myTheme} value={`
                        
                        
                        `} height="600px" />
                      </div>
                    </div>
                  </div>
                  {'        '}
                </div>
                {'        '}
                <div
                  className="gutter gutter-horizontal"
                  style={{
                    width: '1px'
                  }}
                />
                <div
                  className="panel-v right"
                  style={{
                    width: 'calc(50% - 0.5px)'
                  }}
                >
                  {'          '}
                  <div
                    className="panel-h panel"
                    style={{
                      height: 'calc(50% - 0.5px)'
                    }}
                  >
                    {'            '}
                    <textarea
                      id="id_code_css"
                      name="code_css"
                      style={{
                        display: 'none'
                      }}
                    />
                    {'                    '}
                    <div className="windowLabelCont">
                      {'          '}
                      <a
                        className="windowLabel"
                        data-panel="css"
                        data-popover-trigger="css"
                        href="#"
                      >
                        {'            '}
                        <span className="label">
                          CSS
                        </span>
                        {'            '}
                        <svg
                          height="7"
                          viewBox="-0.019531 -52.792969 30.039062 25.195312"
                          width="8"
                        >
                          {'              '}
                          <path d="M29.941406 -52.500000C29.785156 -52.656250 29.589844 -52.753906 29.355469 -52.792969L0.644531 -52.792969C0.410156 -52.753906 0.214844 -52.656250 0.058594 -52.500000C-0.019531 -52.265625 0.000000 -52.050781 0.117188 -51.855469L14.472656 -27.890625C14.628906 -27.734375 14.804688 -27.636719 15.000000 -27.597656C15.234375 -27.636719 15.410156 -27.734375 15.527344 -27.890625L29.882812 -51.855469C30.000000 -52.089844 30.019531 -52.304688 29.941406 -52.500000ZM29.941406 -52.500000" />
                          {'            '}
                        </svg>
                        {'          '}
                      </a>
                      {'          '}
                      <a
                        className="panelTidy"
                        data-panel="css"
                        href="#"
                      >
                        {'          '}
                        <svg
                          className="feather feather-align-left"
                          fill="none"
                          height="14"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.4"
                          viewBox="0 0 24 24"
                          width="14"
                        >
                          <line
                            x1="17"
                            x2="3"
                            y1="10"
                            y2="10"
                          />
                          <line
                            x1="21"
                            x2="3"
                            y1="6"
                            y2="6"
                          />
                          <line
                            x1="21"
                            x2="3"
                            y1="14"
                            y2="14"
                          />
                          <line
                            x1="17"
                            x2="3"
                            y1="18"
                            y2="18"
                          />
                        </svg>
                        {' '}Tidy
                      </a>
                      {'        '}
                    </div>
                    {'          '}
                    <div
                      className="CodeMirror cm-s-default CodeMirror-wrap fontSize_1"
                      style={{
                        clipPath: 'inset(0px)'
                      }}
                      translate="no"
                    >
                      <div
                        style={{
                          height: '0px',
                          left: '69.2031px',
                          overflow: 'hidden',
                          position: 'relative',
                          top: '54.4px',
                          width: '3px'
                        }}
                      >
                        <textarea
                          autoCapitalize="off"
                          autoCorrect="off"
                          spellCheck="false"
                          style={{
                            bottom: '-1em',
                            height: '1em',
                            minHeight: '1em',
                            outline: 'none',
                            padding: '0px',
                            position: 'absolute',
                            width: '1000px'
                          }}
                          tabIndex="0"
                        />
                      </div>
                      <div
                        className="CodeMirror-vscrollbar"
                        cm-not-content="true"
                        style={{
                          visibility: 'hidden',
                          width: '18px'
                        }}
                        tabIndex="-1"
                      >
                        <div
                          style={{
                            height: '0px',
                            minWidth: '1px'
                          }}
                        />
                      </div>
                      <div
                        className="CodeMirror-hscrollbar"
                        cm-not-content="true"
                        style={{
                          height: '18px',
                          visibility: 'hidden'
                        }}
                        tabIndex="-1"
                      >
                        <div
                          style={{
                            height: '100%',
                            minHeight: '1px',
                            width: '0px'
                          }}
                        />
                      </div>
                      <div
                        className="CodeMirror-scrollbar-filler"
                        cm-not-content="true"
                      />
                      <div
                        className="CodeMirror-gutter-filler"
                        cm-not-content="true"
                      />
                      <div>
                      <CodeMirror extensions={cssLanguage} options={{
    mode: 'css', // Set the syntax highlighting mode to 'css'
    theme: 'material', // Set the CodeMirror theme
    lineNumbers: true, // Enable line numbers
  }}
  theme={myTheme} value={`
body {
  color: blue;
  font-size: 42px;
}
                        
                        `} height="600px" />
                      </div>
                    </div>
                  </div>
                  {'          '}
                  <div
                    className="gutter gutter-vertical"
                    style={{
                      height: '1px'
                    }}
                  />
                  <div
                    className="panel-h panel resultsPanel"
                    style={{
                      height: 'calc(50% - 0.5px)'
                    }}
                  >
                    {'                    '}
                    <div className="resultsCont minimized consoleEnabled">
                      {'          '}
                      <div className="iframeCont">
                        {'            '}
                        <iframe
                          allow="midi; geolocation; microphone; camera; display-capture; encrypted-media; clipboard-read; clipboard-write; notifications; payment-handler; persistent-storage; background-sync; ambient-light-sensor; accessibility-events;"
                          allowFullScreen
                          allowpaymentrequest=""
                          frameBorder="0"
                          name="result"
                          sandbox="allow-modals allow-forms allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation allow-downloads"
                          src=""
                        >
                          {'            '}
                        </iframe>
                        {'          '}
                      </div>
                      {'                  '}
                      <div className="windowLabelCont">
                        {'          '}
                        <span className="windowLabel hidden">
                          {'            '}Result{'          '}
                        </span>
                        {'          '}
                        <em className="size hidden">
                          651px
                        </em>
                        {'        '}
                      </div>
                      {'        '}
                      <div id="console">
                        <section className="header">
                          {'      '}
                          <svg
                            className="logo"
                            height="16"
                            version="1.1"
                            viewBox="0 0 24 24"
                          >
                            <g
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="1.8"
                            >
                              <polyline points="4,17 10,11 4,5" />
                              <line
                                x1="12"
                                x2="20"
                                y1="19"
                                y2="19"
                              />
                            </g>
                          </svg>
                          {'      '}
                          <h3>
                            Console (beta)
                          </h3>
                          {'      '}
                          <div className="consoleActions">
                            {'        '}
                            <a
                              href="#"
                              id="console-clear"
                            >
                              Clear console
                            </a>
                            {'        '}
                            <a
                              href="#"
                              id="console-minimize"
                            >
                              Minimize
                            </a>
                            {'      '}
                          </div>
                          {'    '}
                          <div id="console-summary">
                            {'    '}
                            <span className="log ">
                              {'      '}
                              <svg
                                height="12"
                                version="1.1"
                                viewBox="0 0 24 24"
                              >
                                <g
                                  fill="none"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="1.8"
                                >
                                  <circle
                                    cx="12"
                                    cy="12"
                                    r="10"
                                  />
                                  <line
                                    x1="12"
                                    x2="12"
                                    y1="8"
                                    y2="12"
                                  />
                                  <line
                                    x1="12"
                                    x2="12.01"
                                    y1="16"
                                    y2="16"
                                  />
                                </g>
                              </svg>
                              0{'    '}
                            </span>
                            {'    '}
                            <span className="info ">
                              {'      '}
                              <svg
                                height="12"
                                version="1.1"
                                viewBox="0 0 24 24"
                              >
                                <g
                                  fill="none"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                >
                                  <circle
                                    cx="12"
                                    cy="12"
                                    r="10"
                                  />
                                  <line
                                    x1="12"
                                    x2="12"
                                    y1="8"
                                    y2="12"
                                  />
                                  <line
                                    x1="12"
                                    x2="12.01"
                                    y1="16"
                                    y2="16"
                                  />
                                </g>
                              </svg>
                              0{'    '}
                            </span>
                            {'    '}
                            <span className="warn ">
                              {'      '}
                              <svg
                                height="12"
                                version="1.1"
                                viewBox="0 0 24 24"
                              >
                                <g
                                  fill="none"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                >
                                  <path d="M10.29 3.86l-8.47 14.14 -7.80912e-08 1.35236e-07c-.552351.956547-.224686 2.17975.73186 2.7321 .297614.171855.634491.264121.97814.267898h16.94l-1.12917e-07 1.24109e-09c1.1045-.0121397 1.99004-.917357 1.9779-2.02186 -.00377709-.343648-.0960428-.680526-.267898-.97814l-8.47-14.14 1.92952e-08 3.18097e-08c-.572861-.944407-1.80285-1.2456-2.74726-.672744 -.275097.166869-.505875.397647-.672744.672744Z" />
                                  <line
                                    x1="12"
                                    x2="12"
                                    y1="9"
                                    y2="13"
                                  />
                                  <line
                                    x1="12"
                                    x2="12.01"
                                    y1="17"
                                    y2="17"
                                  />
                                </g>
                              </svg>
                              0{'    '}
                            </span>
                            {'    '}
                            <span className="error ">
                              {'      '}
                              <svg
                                height="12"
                                version="1.1"
                                viewBox="0 0 24 24"
                              >
                                <g
                                  fill="none"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                >
                                  <polygon points="7.86,2 16.14,2 22,7.86 22,16.14 16.14,22 7.86,22 2,16.14 2,7.86 7.86,2" />
                                  <line
                                    x1="12"
                                    x2="12"
                                    y1="8"
                                    y2="12"
                                  />
                                  <line
                                    x1="12"
                                    x2="12.01"
                                    y1="16"
                                    y2="16"
                                  />
                                </g>
                              </svg>
                              0{'    '}
                            </span>
                            {'    '}
                          </div>
                        </section>
                        <ul id="console-output">
                          <li className="system">
                            JSFiddle Console (beta). Turn on/off in Editor settings.
                          </li>
                          <li className="system">
                            ☁️ "Running fiddle"
                          </li>
                          <li className="system">
                            ☁️ "Running fiddle"
                          </li>
                          <li className="system">
                            ☁️ "Running fiddle"
                          </li>
                          <li className="system">
                            ☁️ "Running fiddle"
                          </li>
                          <li className="system">
                            ☁️ "Running fiddle"
                          </li>
                          <li className="system">
                            ☁️ "Running fiddle"
                          </li>
                          <li className="system">
                            ☁️ "Running fiddle"
                          </li>
                          <li className="system">
                            ☁️ "Running fiddle"
                          </li>
                          <li className="system">
                            ☁️ "Running fiddle"
                          </li>
                        </ul>
                        <input
                          id="console-input"
                          placeholder=">_"
                          type="text"
                        />
                      </div>
                    </div>
                    {'          '}
                  </div>
                  {'        '}
                </div>
              </div>
              <div
                className="windowSettings html hidden"
                data-panel="html"
                data-popover-ref="html"
              >
                {'  '}
                <h3>
                  Language
                </h3>
                <div className="selectCont">
                  {'  '}
                  <select
                    className="panelChoice"
                    data-panel="html"
                    data-panel_id="id_code_html"
                    id="panel_html_choice"
                    name="panel_html"
                  >
                    {'      '}
                    <option
                      data-mime-type="text/html"
                      selected
                      value="0"
                    >
                      HTML
                    </option>
                    {'      '}
                    <option
                      data-mime-type="text/x-haml"
                      value="1"
                    >
                      HAML
                    </option>
                    {'  '}
                  </select>
                  {'  '}
                  <label>
                    {'    '}
                    <svg
                      fill="none"
                      height="24"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.4"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                    {'  '}
                  </label>
                </div>
                {' '}
                <h3>
                  Doctype
                </h3>
                <div className="selectCont">
                  {'  '}
                  <select name="doctype">
                    {'      '}
                    <option
                      id="dtd_XHTML 1.0 Strict"
                      value="1"
                    >
                      XHTML 1.0 Strict
                    </option>
                    {'      '}
                    <option
                      id="dtd_XHTML 1.0 Transitional"
                      value="2"
                    >
                      XHTML 1.0 Transitional
                    </option>
                    {'      '}
                    <option
                      id="dtd_HTML 5"
                      selected
                      value="3"
                    >
                      HTML 5
                    </option>
                    {'      '}
                    <option
                      id="dtd_HTML 4.01 Strict"
                      value="4"
                    >
                      HTML 4.01 Strict
                    </option>
                    {'      '}
                    <option
                      id="dtd_HTML 4.01 Transitional"
                      value="5"
                    >
                      HTML 4.01 Transitional
                    </option>
                    {'      '}
                    <option
                      id="dtd_HTML 4.01 Frameset"
                      value="6"
                    >
                      HTML 4.01 Frameset
                    </option>
                    {'  '}
                  </select>
                  {'  '}
                  <label>
                    {'    '}
                    <svg
                      fill="none"
                      height="24"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.4"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                    {'  '}
                  </label>
                </div>
                <h3>
                  Body tag
                </h3>
                <p>
                  {'  '}
                  <label>
                    {'    '}
                    <input
                      defaultValue=""
                      id="id_body_tag"
                      maxLength="255"
                      name="body_tag"
                      type="text"
                    />
                    {'  '}
                  </label>
                </p>
              </div>
              {' '}
              <div
                className="windowSettings js hidden"
                data-panel="js"
                data-popover-ref="js"
                style={{
                  left: '-32px',
                  position: 'absolute',
                  top: '404px'
                }}
              >
                {'  '}
                <h3>
                  Language
                </h3>
                <div className="selectCont">
                  {'  '}
                  <select
                    className="panelChoice"
                    data-panel="js"
                    data-panel_id="id_code_js"
                    id="panel_js_choice"
                    name="panel_js"
                  >
                    {'      '}
                    <option
                      data-mime-type="text/javascript"
                      selected
                      value="0"
                    >
                      JavaScript
                    </option>
                    {'      '}
                    <option
                      data-mime-type="text/coffeescript"
                      value="1"
                    >
                      CoffeeScript
                    </option>
                    {'      '}
                    <option
                      data-mime-type="application/javascript"
                      value="2"
                    >
                      JavaScript 1.7
                    </option>
                    {'      '}
                    <option
                      data-mime-type="text/jsx"
                      value="3"
                    >
                      Babel + JSX
                    </option>
                    {'      '}
                    <option
                      data-mime-type="text/typescript"
                      value="4"
                    >
                      TypeScript
                    </option>
                    {'      '}
                    <option
                      data-mime-type="text/coffeescript"
                      value="5"
                    >
                      CoffeeScript 2
                    </option>
                    {'      '}
                    <option
                      data-mime-type="text/javascript"
                      value="6"
                    >
                      Vue
                    </option>
                    {'      '}
                    <option
                      data-mime-type="text/jsx"
                      value="7"
                    >
                      React
                    </option>
                    {'      '}
                    <option
                      data-mime-type="text/jsx"
                      value="8"
                    >
                      Preact
                    </option>
                    {'  '}
                  </select>
                  {'  '}
                  <label>
                    {'    '}
                    <svg
                      fill="none"
                      height="24"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.4"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                    {'  '}
                  </label>
                </div>
                {' '}
                <h3>
                  Frameworks & Extensions
                </h3>
                <div className="panelExtrasChoice">
                  {'  '}
                  <div className="selectCont">
                    {'    '}
                    <select
                      id="js_lib"
                      name="js_lib"
                    >
                      {'        '}
                      <optgroup label="Alpine.js">
                        {'          '}
                        <option value="409">
                          Alpine.js 2.1.2
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="AngularJS">
                        {'          '}
                        <option value="137">
                          AngularJS 1.1.1
                        </option>
                        {'          '}
                        <option value="180">
                          AngularJS 1.2.1
                        </option>
                        {'          '}
                        <option value="283">
                          AngularJS 1.4.8
                        </option>
                        {'          '}
                        <option value="281">
                          AngularJS 2.0.0-alpha.47
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Bonsai">
                        {'          '}
                        <option value="120">
                          Bonsai 0.4.1
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Brick">
                        {'          '}
                        <option value="176">
                          Brick edge
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="CreateJS">
                        {'          '}
                        <option value="170">
                          CreateJS 2013.09.25
                        </option>
                        {'          '}
                        <option value="279">
                          CreateJS 2015.05.21
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="D3">
                        {'          '}
                        <option value="134">
                          D3 3.x
                        </option>
                        {'          '}
                        <option value="386">
                          D3 4.13.0
                        </option>
                        {'          '}
                        <option value="397">
                          D3 5.9.2
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Dojo">
                        {'          '}
                        <option value="87">
                          Dojo (nightly)
                        </option>
                        {'          '}
                        <option value="372">
                          Dojo 1.4.8
                        </option>
                        {'          '}
                        <option value="370">
                          Dojo 1.5.6
                        </option>
                        {'          '}
                        <option value="368">
                          Dojo 1.6.5
                        </option>
                        {'          '}
                        <option value="366">
                          Dojo 1.7.12
                        </option>
                        {'          '}
                        <option value="364">
                          Dojo 1.8.14
                        </option>
                        {'          '}
                        <option value="362">
                          Dojo 1.9.11
                        </option>
                        {'          '}
                        <option value="360">
                          Dojo 1.10.8
                        </option>
                        {'          '}
                        <option value="358">
                          Dojo 1.11.4
                        </option>
                        {'          '}
                        <option value="356">
                          Dojo 1.12.2
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Ember">
                        {'          '}
                        <option value="190">
                          Ember (latest)
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Enyo">
                        {'          '}
                        <option value="115">
                          Enyo (nightly)
                        </option>
                        {'          '}
                        <option value="116">
                          Enyo 2.0.1
                        </option>
                        {'          '}
                        <option value="121">
                          Enyo 2.1
                        </option>
                        {'          '}
                        <option value="145">
                          Enyo 2.2.0
                        </option>
                        {'          '}
                        <option value="214">
                          Enyo 2.4.0
                        </option>
                        {'          '}
                        <option value="238">
                          Enyo 2.5.1
                        </option>
                        {'          '}
                        <option value="299">
                          Enyo 2.7.0
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="ExtJS">
                        {'          '}
                        <option value="23">
                          ExtJS 3.1.0
                        </option>
                        {'          '}
                        <option value="109">
                          ExtJS 3.4.0
                        </option>
                        {'          '}
                        <option value="107">
                          ExtJS 4.1.0
                        </option>
                        {'          '}
                        <option value="80">
                          ExtJS 4.1.1
                        </option>
                        {'          '}
                        <option value="147">
                          ExtJS 4.2.0
                        </option>
                        {'          '}
                        <option value="258">
                          ExtJS 5.0.0
                        </option>
                        {'          '}
                        <option value="256">
                          ExtJS 5.1.0
                        </option>
                        {'          '}
                        <option value="338">
                          ExtJS 6.2.0
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="FabricJS">
                        {'          '}
                        <option value="250">
                          FabricJS 1.5.0
                        </option>
                        {'          '}
                        <option value="342">
                          FabricJS 1.7.7
                        </option>
                        {'          '}
                        <option value="378">
                          FabricJS 1.7.15
                        </option>
                        {'          '}
                        <option value="380">
                          FabricJS 1.7.20
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Glow">
                        {'        '}
                      </optgroup>
                      <optgroup label="Inferno">
                        {'          '}
                        <option value="336">
                          Inferno 1.0.0-beta9
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="JSBlocks">
                        {'          '}
                        <option value="252">
                          JSBlocks (edge)
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="KineticJS">
                        {'          '}
                        <option value="124">
                          KineticJS 4.0.5
                        </option>
                        {'          '}
                        <option value="139">
                          KineticJS 4.3.1
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Knockout.js">
                        {'          '}
                        <option value="104">
                          Knockout.js 2.0.0
                        </option>
                        {'          '}
                        <option value="117">
                          Knockout.js 2.1.0
                        </option>
                        {'          '}
                        <option value="122">
                          Knockout.js 2.2.1
                        </option>
                        {'          '}
                        <option value="163">
                          Knockout.js 2.3.0
                        </option>
                        {'          '}
                        <option value="172">
                          Knockout.js 3.0.0
                        </option>
                        {'          '}
                        <option value="388">
                          Knockout.js 3.4.2
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Lo-Dash">
                        {'          '}
                        <option value="167">
                          Lo-Dash 2.2.1
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Minified">
                        {'          '}
                        <option value="164">
                          Minified 1.0 beta1
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="MithrilJS">
                        {'          '}
                        <option value="273">
                          MithrilJS 0.2.0
                        </option>
                        {'          '}
                        <option value="390">
                          MithrilJS 1.1.6
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Mootools">
                        {'          '}
                        <option value="59">
                          Mootools (nightly)
                        </option>
                        {'          '}
                        <option value="62">
                          Mootools 1.3.2
                        </option>
                        {'          '}
                        <option value="63">
                          Mootools 1.3.2 (compat)
                        </option>
                        {'          '}
                        <option value="95">
                          Mootools 1.4.5
                        </option>
                        {'          '}
                        <option value="96">
                          Mootools 1.4.5 (compat)
                        </option>
                        {'          '}
                        <option value="216">
                          Mootools 1.5.1
                        </option>
                        {'          '}
                        <option value="263">
                          Mootools 1.5.2
                        </option>
                        {'          '}
                        <option value="329">
                          Mootools 1.5.2 (compat)
                        </option>
                        {'          '}
                        <option value="325">
                          Mootools 1.6.0
                        </option>
                        {'          '}
                        <option value="327">
                          Mootools 1.6.0 (compat)
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="No-Library">
                        {'          '}
                        <option
                          selected
                          value="11"
                        >
                          No-Library (pure JS)
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="OpenUI5">
                        {'          '}
                        <option value="271">
                          OpenUI5 (latest, mobile)
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Paper.js">
                        {'          '}
                        <option value="158">
                          Paper.js 0.22
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Pixi">
                        {'          '}
                        <option value="315">
                          Pixi 3.0.11
                        </option>
                        {'          '}
                        <option value="331">
                          Pixi 4.0.0
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Processing.js">
                        {'          '}
                        <option value="67">
                          Processing.js 1.2.3
                        </option>
                        {'          '}
                        <option value="81">
                          Processing.js 1.3.6
                        </option>
                        {'          '}
                        <option value="135">
                          Processing.js 1.4.1
                        </option>
                        {'          '}
                        <option value="206">
                          Processing.js 1.4.7
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Prototype">
                        {'          '}
                        <option value="4">
                          Prototype 1.6.1.0
                        </option>
                        {'          '}
                        <option value="265">
                          Prototype 1.7.3
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="RactiveJS">
                        {'          '}
                        <option value="287">
                          RactiveJS 0.7.3
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Raphael">
                        {'          '}
                        <option value="30">
                          Raphael 1.4
                        </option>
                        {'          '}
                        <option value="36">
                          Raphael 1.5.2
                        </option>
                        {'          '}
                        <option value="76">
                          Raphael 2.1.0
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="React">
                        {'          '}
                        <option value="159">
                          React 0.3.2
                        </option>
                        {'          '}
                        <option value="166">
                          React 0.4.0
                        </option>
                        {'          '}
                        <option value="184">
                          React 0.8.0
                        </option>
                        {'          '}
                        <option value="192">
                          React 0.9.0
                        </option>
                        {'          '}
                        <option value="285">
                          React 0.14.3
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="RightJS">
                        {'          '}
                        <option value="45">
                          RightJS 2.1.1
                        </option>
                        {'          '}
                        <option value="136">
                          RightJS 2.3.1
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Riot">
                        {'          '}
                        <option value="382">
                          Riot 3.7.4
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Shipyard">
                        {'          '}
                        <option value="99">
                          Shipyard (nightly)
                        </option>
                        {'          '}
                        <option value="105">
                          Shipyard 0.2
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Thorax">
                        {'          '}
                        <option value="143">
                          Thorax 2.0.0rc3
                        </option>
                        {'          '}
                        <option value="174">
                          Thorax 2.0.0rc6
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Three.js">
                        {'          '}
                        <option value="82">
                          Three.js r54
                        </option>
                        {'          '}
                        <option value="399">
                          Three.js 105
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Underscore">
                        {'          '}
                        <option value="111">
                          Underscore 1.3.3
                        </option>
                        {'          '}
                        <option value="133">
                          Underscore 1.4.3
                        </option>
                        {'          '}
                        <option value="160">
                          Underscore 1.4.4
                        </option>
                        {'          '}
                        <option value="267">
                          Underscore 1.8.3
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Vue">
                        {'          '}
                        <option value="236">
                          Vue (edge)
                        </option>
                        {'          '}
                        <option value="289">
                          Vue 1.0.12
                        </option>
                        {'          '}
                        <option value="344">
                          Vue 2.2.1
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="WebApp Install">
                        {'          '}
                        <option value="142">
                          WebApp Install 0.1
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="XTK">
                        {'          '}
                        <option value="106">
                          XTK edge
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="YUI">
                        {'          '}
                        <option value="9">
                          YUI 2.8.0r4
                        </option>
                        {'          '}
                        <option value="102">
                          YUI 3.5.0
                        </option>
                        {'          '}
                        <option value="118">
                          YUI 3.6.0
                        </option>
                        {'          '}
                        <option value="123">
                          YUI 3.7.3
                        </option>
                        {'          '}
                        <option value="130">
                          YUI 3.8.0
                        </option>
                        {'          '}
                        <option value="153">
                          YUI 3.10.1
                        </option>
                        {'          '}
                        <option value="182">
                          YUI 3.14.0
                        </option>
                        {'          '}
                        <option value="204">
                          YUI 3.16.0
                        </option>
                        {'          '}
                        <option value="230">
                          YUI 3.17.2
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="Zepto">
                        {'          '}
                        <option value="90">
                          Zepto 1.0rc1
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="jQuery">
                        {'          '}
                        <option value="46">
                          jQuery (edge)
                        </option>
                        {'          '}
                        <option value="131">
                          jQuery 1.9.1
                        </option>
                        {'          '}
                        <option value="248">
                          jQuery 2.1.3
                        </option>
                        {'          '}
                        <option value="319">
                          jQuery 2.2.4
                        </option>
                        {'          '}
                        <option value="376">
                          jQuery 3.2.1
                        </option>
                        {'          '}
                        <option value="384">
                          jQuery 3.3.1
                        </option>
                        {'          '}
                        <option value="401">
                          jQuery 3.4.1
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="jQuery Slim">
                        {'          '}
                        <option value="407">
                          jQuery Slim 3.2.1
                        </option>
                        {'          '}
                        <option value="405">
                          jQuery Slim 3.3.1
                        </option>
                        {'          '}
                        <option value="403">
                          jQuery Slim 3.4.1
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="jTypes">
                        {'          '}
                        <option value="165">
                          jTypes 2.1.0
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="qooxdoo">
                        {'          '}
                        <option value="127">
                          qooxdoo 2.0.3
                        </option>
                        {'          '}
                        <option value="126">
                          qooxdoo 2.1
                        </option>
                        {'        '}
                      </optgroup>
                      <optgroup label="svg.js">
                        {'          '}
                        <option value="395">
                          svg.js 2.6.5
                        </option>
                        {'          '}
                        <option value="393">
                          svg.js 2.7.1
                        </option>
                        {'          '}
                        <option value="391">
                          svg.js 3.0.5
                        </option>
                        {'    '}
                      </optgroup>
                    </select>
                    {'    '}
                    <label>
                      {'      '}
                      <svg
                        fill="none"
                        height="24"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.4"
                        viewBox="0 0 24 24"
                        width="24"
                      >
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                      {'    '}
                    </label>
                    {'  '}
                  </div>
                  {'  '}
                  <ul id="js_dependency">
                    {'      '}
                  </ul>
                </div>
                <h3>
                  {`Framework <script> attribute`}
                </h3>
                <p className="libraryTagAttributes">
                  {'  '}
                  <label>
                    {'    '}
                    <input
                      defaultValue=""
                      id="id_js_lib_option"
                      maxLength="255"
                      name="js_lib_option"
                      placeholder="ie. data-type=&quot;&quot;"
                      type="text"
                    />
                    {'  '}
                  </label>
                </p>
              </div>
              {' '}
              <div
                className="windowSettings css hidden"
                data-panel="css"
                data-popover-ref="css"
              >
                {'  '}
                <h3>
                  Language
                </h3>
                <div className="selectCont">
                  {'  '}
                  <select
                    className="panelChoice"
                    data-panel="css"
                    data-panel_id="id_code_css"
                    id="panel_css_choice"
                    name="panel_css"
                  >
                    {'      '}
                    <option
                      data-mime-type="text/css"
                      selected
                      value="0"
                    >
                      CSS
                    </option>
                    {'      '}
                    <option
                      data-mime-type="text/x-scss"
                      value="1"
                    >
                      SCSS
                    </option>
                    {'      '}
                    <option
                      data-mime-type="text/x-sass"
                      value="2"
                    >
                      SASS
                    </option>
                    {'      '}
                    <option
                      data-mime-type="text/css"
                      value="4"
                    >
                      PostCSS (Stage 0+)
                    </option>
                    {'      '}
                    <option
                      data-mime-type="text/css"
                      value="5"
                    >
                      PostCSS (Stage 3+)
                    </option>
                    {'  '}
                  </select>
                  {'  '}
                  <label>
                    {'    '}
                    <svg
                      fill="none"
                      height="24"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.4"
                      viewBox="0 0 24 24"
                      width="24"
                    >
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                    {'  '}
                  </label>
                </div>
                {' '}
                <h3>
                  Options
                </h3>
                <p id="normalize_check">
                  {'  '}
                  <label className="checkboxCont">
                    {'    '}
                    <input
                      defaultValue="1"
                      id="id_normalize_css"
                      name="normalize_css"
                      type="checkbox"
                    />
                    {'    '}
                    <span className="checkbox">
                      <i className="bts bt-check" />
                    </span>
                    {' '}Normalized CSS{'  '}
                  </label>
                </p>
              </div>
              {' '}
              <div id="problem-banner" />
              {'          '}
            </div>
            {'                     '}
            <ul
              className="draft hidden"
              id="flash-messages"
            >
              {'  '}
              <li className="warning">
                {'    '}
                <svg
                  version="1.1"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <g
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <polyline points="23,4 23,10 17,10" />
                    <path d="M20.49 15l8.16053e-09-2.30983e-08c-1.65578 4.68667-6.79735 7.1437-11.484 5.48792 -4.68667-1.65578-7.1437-6.79735-5.48792-11.484 1.65578-4.68667 6.79735-7.1437 11.484-5.48792 1.26714.447675 2.41794 1.17344 3.36792 2.12402l4.63 4.36" />
                  </g>
                </svg>
                {'    '}This fiddle has previously unsaved changes.{'    '}
                <span className="flashActions">
                  {'      '}
                  <a
                    href="#"
                    id="apply-draft"
                  >
                    Apply changes
                  </a>
                  {'      '}
                  <a
                    href="#"
                    id="discard-draft"
                  >
                    Discard
                  </a>
                  {'    '}
                </span>
                {'  '}
              </li>
            </ul>
            {'        '}
          </main>
          {'       '}
          <div id="loader">
            {'        '}
            <svg
              className="loader"
              viewBox="0 0 46 33"
              xmlns="http://www.w3.org/2000/svg"
            >
              {'          '}
              <g
                fill="none"
                fillRule="evenodd"
                strokeWidth="1"
              >
                {'            '}
                <path
                  className="cloud"
                  d="M45,22.7331459 C45,19.1499462 42.7950446,16.079593 39.6628004,14.7835315 C39.6774469,14.5246474 39.7003932,14.2674038 39.7003932,14.0035978 C39.7003932,6.82243304 33.8412885,1 26.611593,1 C21.3985635,1 16.9102123,4.03409627 14.8051788,8.41527616 C13.7828502,7.62878013 12.503719,7.15547161 11.1134367,7.15547161 C7.77825654,7.15547161 5.07450503,9.84159999 5.07450503,13.1544315 C5.07450503,13.7760488 5.16938207,14.3779791 5.3477444,14.9418479 C2.74863428,16.4787471 1,19.2867709 1,22.5105187 C1,27.3287502 4.89630545,31.2367856 9.72803666,31.31094 L36.3341301,31.3109406 C41.1201312,31.3406346 45,27.4870665 45,22.7331459 L45,22.7331459 Z"
                  strokeLinejoin="round"
                />
                {'            '}
                <path
                  className="loop"
                  d="M25.3570852,17.8208603            C26.0154526,17.1207706 27.1652748,15.6666667 29.5167986,15.6666667            C32.1278053,15.6666667 34.2444444,17.6366138 34.2444444,20.0666667            C34.2444444,22.4967196 32.1278053,24.4666667 29.5167986,24.4666667            C26.9249697,24.4666667 24.5595344,21.7145959 23.4888889,20.543316            C21.4404656,18.4187374 19.0750303,15.6666667 16.4832014,15.6666667            C13.8721947,15.6666667 11.7555556,17.6366138 11.7555556,20.0666667            C11.7555556,22.4967196 13.8721947,24.4666667 16.4832014,24.4666667            C18.8347252,24.4666667 19.9845474,23.0125628 20.6429148,22.312473            L25.3570852,17.8208603"
                  strokeLinecap="round"
                />
                {'          '}
              </g>
              {'        '}
            </svg>
            {'        '}
            <span className="shadow" />
            {'      '}
          </div>
          {'    '}
        </form>
        {'                        '}
        <div
          className="autocomplete-suggestions "
          style={{
            left: '0px',
            top: '1px',
            width: '0px'
          }}
        />
      </body>
    </html>
      )
}
